import { Autocomplete, Box, Checkbox, Chip, Grid, InputLabel, Paper, TextField, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone/.';
import PhoneInput from 'react-phone-input-2';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const InputsRendered = ({ handleIpChangeChange, inputFieldsArr = [], inputFieldsData }) => {
  return (
    <Grid
      container
      spacing={1}
      sx={{
        '& .MuiTableCell-root': {
          fontSize: '0.825rem',
        },
        '& .MuiInputBase-root': {
          fontSize: '0.825rem !important',
        },
      }}>
      {inputFieldsArr.map((inputProps, index) => {
        if (inputProps.typeOfInp == 'select') {
          return (
            <Grid item xs={6} sm={6} md={inputProps.width || 3} key={`${inputProps.name}_${index}`}>
              <InputLabel
                size="small"
                sx={{
                  paddingBottom: '10px',
                  fontSize: '0.825rem',
                  color: 'black',
                }}
                required={inputProps.required}>
                {inputProps.label}
              </InputLabel>

              <Autocomplete
                size="small"
                disablePortal
                name={inputProps.name}
                value={inputFieldsData[inputProps.name] || null}
                options={inputProps.options || []}
                onChange={(event, newValue) => handleIpChangeChange(inputProps.name, newValue)}
                sx={{ fontSize: '0.8rem' }}
                renderInput={params => <TextField helperText={inputProps.helperText} {...params} size="small" fullWidth />}
                fullWidth
              />
            </Grid>
          );
        } else if (inputProps.typeOfInp == 'objectSelect') {
          return (
            <Grid item xs={6} sm={6} md={inputProps.width || 3} key={`${inputProps.name}_${index}`}>
              <InputLabel
                size="small"
                sx={{
                  paddingBottom: '10px',
                  fontSize: '0.825rem',
                  color: 'black',
                }}
                required={inputProps.required}>
                {inputProps.label}
              </InputLabel>

              <Autocomplete
                size="small"
                disablePortal
                name={inputProps.name}
                value={
                  inputProps.getValueFnc
                    ? inputProps.getValueFnc(inputFieldsData[inputProps.name])
                    : inputFieldsData[inputProps.name] || null
                }
                options={inputProps.options || []}
                onChange={(event, newValue) => handleIpChangeChange(inputProps.name, newValue)}
                sx={{ fontSize: '0.8rem' }}
                renderInput={params => <TextField helperText={inputProps.helperText} {...params} size="small" fullWidth />}
                fullWidth
                getOptionLabel={inputProps.getOptionLabel}
                isOptionEqualToValue={inputProps.isOptionEqualToValue}
              />
            </Grid>
          );
        } else if (inputProps.typeOfInp == 'phone') {
          return (
            <Grid item xs={6} sm={6} md={inputProps.width || 3} key={`${inputProps.name}_${index}`}>
              <InputLabel
                size="small"
                sx={{
                  paddingBottom: '10px',
                  fontSize: '0.825rem',
                  color: 'black',
                }}
                required={inputProps.required}>
                {inputProps.label}
              </InputLabel>

              <PhoneInput
                country={'ie'}
                value={inputFieldsData[inputProps.name] || ''}
                onChange={phone => handleIpChangeChange(inputProps.name, phone)}
                inputProps={{
                  required: inputProps.required,
                  name: inputProps.name,
                }}
                inputStyle={{
                  width: '100%',
                }}
              />
            </Grid>
          );
        } else if (inputProps.typeOfInp == 'checkbox') {
          return (
            <Grid item xs={6} sm={6} md={inputProps.width || 3} key={`${inputProps.name}_${index}`}>
              <InputLabel
                size="small"
                sx={{
                  paddingBottom: '10px',
                  fontSize: '0.825rem',
                  color: 'black',
                }}
                required={inputProps.required}>
                {inputProps.label}
              </InputLabel>

              <Checkbox
                name={inputProps.name}
                checked={inputFieldsData[inputProps.name]}
                onChange={event => handleIpChangeChange(inputProps.name, event.target.checked)}
              />
            </Grid>
          );
        } else {
          return (
            <Grid item xs={6} sm={6} md={inputProps.width || 3} key={`${inputProps.name}_${index}`}>
              <InputLabel
                size="small"
                sx={{
                  paddingBottom: '10px',
                  fontSize: '0.825rem',
                  color: 'black',
                }}
                required={inputProps.required}>
                {inputProps.label}
              </InputLabel>

              <TextField
                size="small"
                variant="outlined"
                type={inputProps.textFieldType || 'text'}
                fullWidth
                value={inputFieldsData[inputProps.name] || ''}
                onChange={e => handleIpChangeChange(inputProps.name, e.target.value)}
                name={inputProps.name}
                required={inputProps.required}
                helperText={inputProps.helperText}
              />
            </Grid>
          );
        }
      })}
    </Grid>
  );
};
export const DropzoneUpload = ({ label, onFileSelect, multiple = false, required = false }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    multiple,
    onDrop: acceptedFiles => {
      const files = multiple ? acceptedFiles : [acceptedFiles[0]];
      setSelectedFiles(files);
      if (onFileSelect) {
        onFileSelect(multiple ? files : files[0]);
      }
    },
  });

  return (
    <Box
      sx={{
        '& .MuiTableCell-root': {
          fontSize: '0.825rem',
        },
        '& .MuiInputBase-root': {
          fontSize: '0.825rem !important',
        },
        '& .MuiTypography-root': {
          fontSize: '0.825rem !important',
        },
      }}>
      <Typography variant="subtitle1" gutterBottom>
        {label}{' '}
        {required && (
          <Typography component="span" color="error">
            *
          </Typography>
        )}
      </Typography>

      <Paper
        {...getRootProps()}
        elevation={0}
        sx={{
          border: '2px dashed #ccc',
          backgroundColor: isDragActive ? '#f0faff' : 'transparent',
          p: 3,
          textAlign: 'center',
          cursor: 'pointer',
          minHeight: 150,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}>
        <input required={required} {...getInputProps()} />
        <CloudUploadIcon sx={{ fontSize: 40, mb: 1, color: 'gray', mx: 'auto' }} />
        <Typography variant="body1" fontWeight="bold">
          Browse Files
        </Typography>
        <Typography variant="body2" color="text.secondary">
          or drag and drop files here
        </Typography>
      </Paper>
      <Box
        mt={1}
        sx={{
          display: 'flex',
          overflowX: 'auto',
          gap: 1,
          py: 1,
          px: 0.5,
        }}>
        {selectedFiles.length > 0 &&
          selectedFiles.map((file, index) => (
            <Tooltip title={file.name}>
              <Chip
                key={index}
                label={file.name.length > 20 ? file.name.slice(0, 18) + '…' : file.name}
                color="primary" // red primary color
                sx={{
                  fontSize: '0.7rem', // Slightly bigger text
                  height: '24px',
                  px: 1,
                }}
              />
            </Tooltip>
          ))}
      </Box>
    </Box>
  );
};
export default InputsRendered;
